// extracted by mini-css-extract-plugin
module.exports = {"pageScope":"pageScope_pageScope__pfAbo"};